var map = {
  "./AverageSpending.svg": "66034",
  "./BasketSize.svg": "51732",
  "./Group.svg": "71638",
  "./KPITrend.svg": "56070",
  "./Kpi.svg": "81185",
  "./KpiCustomer.svg": "80277",
  "./MemberContribution.svg": "94097",
  "./Recruitment.svg": "83809",
  "./RepeatPurchase.svg": "40413",
  "./Retention.svg": "40329",
  "./UPT.svg": "82402",
  "./accountAuthority.svg": "48773",
  "./add.svg": "51458",
  "./add_photo_alternate.svg": "19576",
  "./adjustView.svg": "84175",
  "./admin.svg": "28174",
  "./alipay.svg": "42355",
  "./analysis-of-activity.svg": "94699",
  "./analysisEdit01.svg": "4866",
  "./analysisEdit02.svg": "45617",
  "./analysisEdit03.svg": "47584",
  "./analysisEdit04.svg": "65055",
  "./analysisEdit05.svg": "34062",
  "./analysisEdit06.svg": "33389",
  "./analysisEdit07.svg": "86028",
  "./analysisEdit08.svg": "96555",
  "./analysisEdit09.svg": "19034",
  "./analysisEdit10.svg": "7408",
  "./analysisEdit11.svg": "98529",
  "./analysisEdit12.svg": "9842",
  "./approve-diabled.svg": "71708",
  "./approve-hover.svg": "87405",
  "./approve.svg": "75336",
  "./arrow-drop-down.svg": "139",
  "./arrow-drop-up.svg": "48612",
  "./arrow-right.svg": "7513",
  "./ask.svg": "75308",
  "./auth.svg": "55671",
  "./autoReply.svg": "48268",
  "./behavior.svg": "40063",
  "./bhc.svg": "59938",
  "./black_list.svg": "18085",
  "./blueSure.svg": "97158",
  "./campaign.svg": "2759",
  "./campaignData.svg": "80551",
  "./cardManagement.svg": "73250",
  "./ceshi.svg": "14533",
  "./changeIntegral.svg": "46889",
  "./changeItegralDisabled.svg": "28995",
  "./changeLevel.svg": "29765",
  "./changePassword.svg": "17546",
  "./changeStore.svg": "80736",
  "./chart.svg": "80903",
  "./chooseNewMaterial.svg": "12547",
  "./circleDelete.svg": "84408",
  "./clear.svg": "98252",
  "./clock.svg": "71189",
  "./close.svg": "86579",
  "./commodity.svg": "17584",
  "./computer.svg": "48886",
  "./copy.svg": "80582",
  "./copy2.svg": "89960",
  "./coupon.svg": "13115",
  "./couponData.svg": "52011",
  "./couponImg.svg": "14744",
  "./couponListIcon.svg": "4040",
  "./couponTotal.svg": "58699",
  "./customer.svg": "97557",
  "./data-icon.svg": "16877",
  "./data.svg": "38889",
  "./dataIcon.svg": "16566",
  "./delete-disabled.svg": "49973",
  "./delete-hover.svg": "99221",
  "./delete.svg": "82528",
  "./deleteIcon.svg": "78587",
  "./denglu.svg": "90780",
  "./detail-disabled.svg": "84423",
  "./detail-hover.svg": "80447",
  "./detail.svg": "37614",
  "./dl.svg": "44617",
  "./downLoadFile.svg": "39811",
  "./download.svg": "23141",
  "./download1.0.svg": "36844",
  "./downloadTemplate.svg": "55759",
  "./downlode_default.svg": "39729",
  "./edit-disabled.svg": "19082",
  "./edit-hover.svg": "26232",
  "./edit.svg": "68077",
  "./editNewMaterial.svg": "67522",
  "./electricity.svg": "96348",
  "./emp_analysis.svg": "77206",
  "./emp_search.svg": "14900",
  "./error.svg": "14569",
  "./excitedMember.svg": "69091",
  "./exit.svg": "38737",
  "./exitMeeting.svg": "32628",
  "./export-icon.svg": "75527",
  "./favorite.svg": "17673",
  "./favorite_border.svg": "58350",
  "./firstPurchaseMember.svg": "42646",
  "./fuhe.svg": "82015",
  "./funnelPlot.svg": "57948",
  "./gailan.svg": "42255",
  "./greySure.svg": "3483",
  "./greyTriangle.svg": "69864",
  "./hot.svg": "52358",
  "./icon-modify.svg": "7001",
  "./imgPreview.svg": "55330",
  "./link.svg": "48789",
  "./lishichaxunjilu.svg": "35507",
  "./loginNum.svg": "96304",
  "./material-icon.svg": "2944",
  "./material.svg": "94294",
  "./materialChange.svg": "68394",
  "./materialDelete.svg": "27423",
  "./member-data.svg": "32620",
  "./memberDataDownload.svg": "47991",
  "./menuWxIcon.svg": "89838",
  "./menu_copon.svg": "8156",
  "./menu_copon_use.svg": "62736",
  "./menu_crowd.svg": "88230",
  "./menu_dashborad.svg": "60263",
  "./menu_mm.svg": "25689",
  "./menu_order.svg": "11905",
  "./menu_scene.svg": "22381",
  "./message.svg": "18470",
  "./mima.svg": "10069",
  "./mingxi.svg": "46803",
  "./miniApp.svg": "501",
  "./miniAppLogo.svg": "19032",
  "./modalClose.svg": "32568",
  "./move.svg": "94694",
  "./myTask.svg": "85128",
  "./newMember.svg": "9451",
  "./nkc.svg": "66063",
  "./noSwap.svg": "13001",
  "./notification.svg": "68092",
  "./numberDown.svg": "54582",
  "./numberUp.svg": "32429",
  "./open.svg": "55261",
  "./pageVisityNum.svg": "96722",
  "./pause.svg": "46537",
  "./peopleNum.svg": "27880",
  "./portrayal.svg": "2159",
  "./preview.svg": "3567",
  "./prize-triangle.svg": "63816",
  "./prizeData.svg": "60323",
  "./publicCopy.svg": "18625",
  "./publish-icon.svg": "79992",
  "./qr-icon.svg": "68398",
  "./qr.svg": "22060",
  "./qrCode.svg": "26307",
  "./qrCode2.svg": "61403",
  "./qrText.svg": "53193",
  "./question.svg": "61445",
  "./rankingIcon.svg": "13682",
  "./registeredmember.svg": "70607",
  "./remove.svg": "1725",
  "./restart-disabled.svg": "11839",
  "./restart-hover.svg": "75847",
  "./restart.svg": "42246",
  "./salesNumber.svg": "38604",
  "./salesPair.svg": "37783",
  "./scene-coupon.svg": "5226",
  "./scene-sale.svg": "10589",
  "./sceneData.svg": "32504",
  "./secret.svg": "35841",
  "./selectData.svg": "7129",
  "./sell.svg": "45181",
  "./shopping.svg": "92913",
  "./smsReport.svg": "36330",
  "./stop-disabled.svg": "86374",
  "./stop-hover.svg": "29396",
  "./stop.svg": "75913",
  "./swap.svg": "53236",
  "./syncMaterial.svg": "43543",
  "./templateMessage.svg": "75752",
  "./test-logo.svg": "25739",
  "./ticket.svg": "82425",
  "./time.svg": "54838",
  "./tooltipIcon.svg": "50253",
  "./triangle.svg": "94573",
  "./tupianguanli.svg": "71032",
  "./unbind-icon.svg": "55453",
  "./update.svg": "38302",
  "./updateImg.svg": "67971",
  "./upload.svg": "99922",
  "./uploadFile.svg": "77200",
  "./uploadImg.svg": "32031",
  "./uploadVideo.svg": "55647",
  "./upload_btn.svg": "12531",
  "./userAvatar.svg": "33971",
  "./video.svg": "94266",
  "./weixinMiniApp.svg": "85779",
  "./whiteDel.svg": "96971",
  "./whiteDown.svg": "59064",
  "./whiteFinish.svg": "9817",
  "./whiteSure.svg": "46859",
  "./xAdd.svg": "76472",
  "./xls.svg": "67692",
  "./yulan.svg": "1348",
  "./ziduanguanli.svg": "44510",
  "./zjrscjrs.svg": "86498",
  "./复核.svg": "17906"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 24078;
